import { generate } from 'shortid';
export var BaseMixin = function BaseMixin(chart, props, skipGroup) {
  if (skipGroup === void 0) {
    skipGroup = false;
  }

  var _props$dimension = props.dimension,
      dimension = _props$dimension === void 0 ? null : _props$dimension,
      group = props.group,
      ordering = props.ordering,
      orderFn = props.orderFn,
      title = props.title,
      _props$filterPrefix = props.filterPrefix,
      filterPrefix = _props$filterPrefix === void 0 ? 'Filter' : _props$filterPrefix,
      _props$legend = props.legend,
      legend = _props$legend === void 0 ? null : _props$legend,
      _props$useViewBoxResi = props.useViewBoxResizing,
      useViewBoxResizing = _props$useViewBoxResi === void 0 ? true : _props$useViewBoxResi,
      _props$label = props.label,
      label = _props$label === void 0 ? function (d) {
    if (isNaN(d.key)) {
      return d.key;
    } else {
      d.key = +d.key;
      return d.key.toFixed(2);
    }
  } : _props$label,
      _props$renderLabel = props.renderLabel,
      renderLabel = _props$renderLabel === void 0 ? true : _props$renderLabel,
      _props$preRender = props.preRender,
      preRender = _props$preRender === void 0 ? null : _props$preRender,
      _props$preRedraw = props.preRedraw,
      preRedraw = _props$preRedraw === void 0 ? null : _props$preRedraw,
      height = props.height,
      _props$valueAccessor = props.valueAccessor,
      valueAccessor = _props$valueAccessor === void 0 ? null : _props$valueAccessor;

  if (!skipGroup) {
    if (chart.group() == null && !group) {
      throw new Error('No group, no group set specified');
    } else if (chart.group() == null && group) {
      chart.group(group);
    }
  }

  if (filterPrefix) {
    chart.filterPrefix = filterPrefix;
  }

  if (typeof valueAccessor === 'function') {
    chart.valueAccessor(valueAccessor);
  } // HACK: This replaces a dc.chart baseMixin method that returns a unique string,
  // it temporarily fixes an issue that arise when using dc.js with some compilers
  // that cause chart.anchorName returns a null/empty string


  if (true || typeof chart.anchorName !== 'function' || chart.anchorName() === '' || chart.anchorName() === undefined || chart.anchorName() === null) {
    var _chart = chart;

    var _uq = generate();

    chart.anchorName = function () {
      return 'dc-chart-' + _uq + '-' + _chart.chartID();
    };
  }

  chart.minHeight(75).dimension(dimension).label(label).renderLabel(renderLabel).useViewBoxResizing(useViewBoxResizing);

  if (height) {
    chart.height(height);
  }

  if (typeof title === 'function') {
    chart.title(title());
  }

  if (typeof ordering === 'function') {
    chart.ordering(ordering);
  }

  if (orderFn) {
    chart._computeOrderedGroups = function (data) {
      return data.slice().sort(orderFn);
    };
  }

  if (typeof preRender === 'function') {
    chart.on('preRender', preRender);
  }

  if (typeof preRedraw === 'function') {
    chart.on('preRedraw', preRedraw);
  }

  return chart;
};